var _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrokeIconEtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2742_3201",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9238 5.68265L26.3463 0.563477C29.6601 -1.45289 33.4525 2.34046 31.4367 5.65503L26.3187 14.0796C25.6007 15.2581 25.6007 16.7404 26.3187 17.9282L31.4367 26.3527C33.4525 29.6673 29.6601 33.4606 26.3463 31.4443L17.9238 26.3251C16.7456 25.6069 15.2636 25.6069 14.0762 26.3251L5.65366 31.4443C2.33989 33.4606 -1.45254 29.6673 0.563341 26.3527L5.68128 17.9282C6.39926 16.7497 6.39926 15.2673 5.68128 14.0796L0.563341 5.65503C-1.45254 2.34046 2.33989 -1.45289 5.65366 0.563477L14.0762 5.68265C15.2544 6.40081 16.7364 6.40081 17.9238 5.68265Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9238 5.68265L26.3463 0.563477C29.6601 -1.45289 33.4525 2.34046 31.4367 5.65503L26.3187 14.0796C25.6007 15.2581 25.6007 16.7404 26.3187 17.9282L31.4367 26.3527C33.4525 29.6673 29.6601 33.4606 26.3463 31.4443L17.9238 26.3251C16.7456 25.6069 15.2636 25.6069 14.0762 26.3251L5.65366 31.4443C2.33989 33.4606 -1.45254 29.6673 0.563341 26.3527L5.68128 17.9282C6.39926 16.7497 6.39926 15.2673 5.68128 14.0796L0.563341 5.65503C-1.45254 2.34046 2.33989 -1.45289 5.65366 0.563477L14.0762 5.68265C15.2544 6.40081 16.7364 6.40081 17.9238 5.68265Z",
    fill: "#FEE92B",
    stroke: "#232323",
    strokeWidth: 2,
    mask: "url(#path-1-inside-1_2742_3201)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrokeIconEtc);
export default __webpack_public_path__ + "static/media/stroke-icon-etc.78e3e67e5488fa49eb5e61c037a5d752.svg";
export { ForwardRef as ReactComponent };